import { Formik, Form, ErrorMessage } from 'formik';
import * as yup from 'yup';
import { $t } from 'hooks/i18n';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { DataSource } from 'components/DataSource';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { PageRequestError } from 'components/PageRequestError';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Title } from 'components/Title';
import useApp from 'hooks/useApp';

import useEditPage from 'hooks/useEditPage';
const WorkerlocationsEditPage = (props) => {
		const app = useApp();
	// form validation schema
	const validationSchema = yup.object().shape({
		latitude: yup.number().required().label($t('latitude')),
		longitude: yup.number().required().label($t('longitude')),
		accuracy: yup.number().nullable().label($t('accuracy')),
		battery_level: yup.number().nullable().label($t('batteryLevel')),
		captured_at: yup.string().nullable().label($t('capturedAt')),
		userid: yup.string().required().label($t('userid'))
	});
	// form default values
	const formDefaultValues = {
		latitude: '', 
		longitude: '', 
		accuracy: '', 
		battery_level: '', 
		captured_at: "(getdate())", 
		userid: '', 
	}
	//where page logics resides
	const pageController = useEditPage({ props, formDefaultValues, afterSubmit });
	//destructure and grab what we need
	const { formData, handleSubmit, submitForm, pageReady, loading, saving, apiRequestError, inputClassName } = pageController
	//Event raised on form submit success
	function afterSubmit(response){
		app.flashMsg(props.msgTitle, props.msgAfterSave);
		if(app.isDialogOpen()){
			app.closeDialogs(); // if page is open as dialog, close dialog
		}
		else if(props.redirect) {
			app.navigate(`/workerlocations`);
		}
	}
	// loading form data from api
	if(loading){
		return (
			<div className="p-3 text-center">
				<ProgressSpinner style={{width:'50px', height:'50px'}} />
			</div>
		);
	}
	//display error page 
	if(apiRequestError){
		return (
			<PageRequestError error={apiRequestError} />
		);
	}
	//page is ready when formdata loaded successfully
	if(pageReady){
		return (
<main id="WorkerlocationsEditPage" className="main-page">
    { (props.showHeader) && 
    <section className="page-section mb-3" >
        <div className="container">
            <div className="grid justify-content-between align-items-center">
                { !props.isSubPage && 
                <div className="col-fixed " >
                    <Button onClick={() => app.navigate(-1)} label={$t('')}  className="p-button p-button-text " icon="pi pi-arrow-left"  />
                </div>
                }
                <div className="col " >
                    <Title title={$t('editWorkerLocation')}   titleClass="text-2xl text-primary font-bold" subTitleClass="text-500"      separator={false} />
                </div>
            </div>
        </div>
    </section>
    }
    <section className="page-section " >
        <div className="container">
            <div className="grid ">
                <div className="md:col-9 sm:col-12 comp-grid" >
                    <div >
                        <Formik
                            initialValues={formData}
                            validationSchema={validationSchema} 
                            onSubmit={(values, actions) => {
                            submitForm(values);
                            }
                            }
                            >
                            { (formik) => {
                            return (
                            <Form className={`${!props.isSubPage ? 'card  ' : ''}`}>
                                <div className="grid">
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('latitude')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="latitude"  onChange={formik.handleChange}  value={formik.values.latitude}   label={$t('latitude')} type="number" placeholder={$t('enterLatitude')}  min={0}  step={0.1}    className={inputClassName(formik?.errors?.latitude)} />
                                                <ErrorMessage name="latitude" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('longitude')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="longitude"  onChange={formik.handleChange}  value={formik.values.longitude}   label={$t('longitude')} type="number" placeholder={$t('enterLongitude')}  min={0}  step={0.1}    className={inputClassName(formik?.errors?.longitude)} />
                                                <ErrorMessage name="longitude" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('accuracy')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="accuracy"  onChange={formik.handleChange}  value={formik.values.accuracy}   label={$t('accuracy')} type="number" placeholder={$t('enterAccuracy')}  min={0}  step={0.1}    className={inputClassName(formik?.errors?.accuracy)} />
                                                <ErrorMessage name="accuracy" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('batteryLevel')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="battery_level"  onChange={formik.handleChange}  value={formik.values.battery_level}   label={$t('batteryLevel')} type="number" placeholder={$t('enterBatteryLevel')}  min={0}  step="any"    className={inputClassName(formik?.errors?.battery_level)} />
                                                <ErrorMessage name="battery_level" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('capturedAt')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Calendar name="captured_at" value={formik.values.captured_at} onChange={formik.handleChange} showButtonBar showTime dateFormat="yy-mm-dd" hourFormat="24"showIcon className={inputClassName(formik?.errors?.captured_at)}        />
                                                <ErrorMessage name="captured_at" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('userid')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <DataSource   apiPath="components_data/userid_option_list"  >
                                                    {
                                                    ({ response }) => 
                                                    <>
                                                    <Dropdown  name="userid"     optionLabel="label" optionValue="value" value={formik.values.userid} onChange={formik.handleChange} options={response} label={$t('userid')}  placeholder={$t('selectAValue')}  className={inputClassName(formik?.errors?.userid)}   />
                                                    <ErrorMessage name="userid" component="span" className="p-error" />
                                                    </>
                                                    }
                                                </DataSource>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                { props.showFooter && 
                                <div className="text-center my-3">
                                    <Button onClick={(e) => handleSubmit(e, formik)}  type="submit" label={$t('update')} icon="pi pi-send" loading={saving} />
                                </div>
                                }
                            </Form>
                            );
                            }
                            }
                            </Formik>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
		);
	}
}
WorkerlocationsEditPage.defaultProps = {
	primaryKey: 'location_id',
	pageName: 'workerlocations',
	apiPath: 'workerlocations/edit',
	routeName: 'workerlocationsedit',
	submitButtonLabel: $t('update'),
	formValidationError: $t('formIsInvalid'),
	formValidationMsg: $t('pleaseCompleteTheForm'),
	msgTitle: $t('updateRecord'),
	msgAfterSave: $t('recordUpdatedSuccessfully'),
	msgBeforeSave: $t(''),
	showHeader: true,
	showFooter: true,
	redirect: true,
	isSubPage: false
}
export default WorkerlocationsEditPage;
